import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-pagination-bar',
    templateUrl: './pagination-bar.component.html',
    styleUrls: ['./pagination-bar.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, NgClass, DecimalPipe]
})
export class PaginationBarComponent implements OnChanges {
  @Input()
  gridApi: GridApi;

  @Input()
  page: number;

  pageDropdown: FormControl;

  constructor() {
    this.pageDropdown = new FormControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['page']) {
      this.pageDropdown.setValue(this.currentPage.toString(10));
    }
  }

  get pageOptions(): string[] {
    return Array.from(Array(this.totalPages).keys()).map((page) => (page + 1).toString(10));
  }

  get currentPage(): number {
    return this.gridApi.paginationGetCurrentPage() + 1;
  }

  get totalPages(): number {
    return this.gridApi.paginationGetTotalPages();
  }

  get rowCount(): number {
    return this.gridApi.getServerSideGroupLevelState()[0]?.rowCount;
  }

  get pageSize(): number {
    return this.gridApi.paginationGetPageSize();
  }

  get firstRowDisplayed(): number {
    return this.currentPage * this.pageSize - this.pageSize + 1;
  }

  get lastRowDisplayed(): number {
    const lastRow = this.currentPage * this.pageSize;
    return this.rowCount < lastRow ? this.rowCount : lastRow;
  }

  onPrevious(): void {
    if (this.currentPage > 1) {
      this.gridApi.paginationGoToPreviousPage();
      this.pageDropdown.setValue((Number.parseInt(this.pageDropdown.value, 10) - 1).toString(10));
    }
  }

  onNext(): void {
    if (this.currentPage < this.totalPages) {
      this.gridApi.paginationGoToNextPage();
      this.pageDropdown.setValue((Number.parseInt(this.pageDropdown.value, 10) + 1).toString(10));
    }
  }

  onPageChange(): void {
    this.gridApi.paginationGoToPage(Number.parseInt(this.pageDropdown.value, 10) - 1);
  }
}
